export enum ImportType {
  PRODUCTS = "Products",
  TRANSACTIONS = "Transactions"
}
